import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SubmitDataFilters, SubmitDataPage} from 'src/app/submit-data/models/submit-data.model';

@Injectable({providedIn: 'root'})
export class SubmitDataService {
  private http = inject(HttpClient);

  /**
   * State management/caching is handled by SubmitDataState.
   */
  search(filters: SubmitDataFilters, page: number, perPage: number): Observable<SubmitDataPage> {
    let params = new HttpParams().set('page', page).set('per_page', perPage);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== '' && value != null) {
        params = params.set(key, value);
      }
    }

    return this.http.get<SubmitDataPage>('/api/submit-data', {params});
  }
}
